import React from 'react';
import { Box, Checkbox, FormControlLabel, MenuItem, TextField } from '@mui/material';
import { searchSummary } from '../common/form/MobileFilterCollapse';
import SearchCard, { fieldProps } from '../common/list/SearchCard';

// 사원관리(/employeemng) 검색 영역 - chancemng 설계(fc30533) 적용(2026-10-22).
// "이력 공개 설정"/"추가" 버튼은 breadcrumb action으로 옮겼다(EmpListContainer).
export const EmployeeListBox = ({ formik, onReset }) => {
  return (
    <SearchCard
      summary={searchSummary(formik.values)}
      onSubmit={formik.handleSubmit}
      onReset={onReset}
      submitting={formik.isSubmitting}
      gridSx={{
        gridTemplateAreas: {
          xs: `"useYn" "keyword" "search" "btns"`,
          sm: `"useYn keyword" "search btns"`,
        },
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'minmax(140px, 0.7fr) minmax(180px, 1.3fr)',
        },
        '@media (min-width:1440px)': {
          gridTemplateAreas: `"useYn keyword search btns"`,
          gridTemplateColumns: '140px minmax(160px, 0.8fr) minmax(200px, 1.2fr) 190px',
        },
      }}
    >
      {/* 미사용 */}
      <Box sx={{ gridArea: 'useYn', minWidth: 0, display: 'flex', alignItems: 'center' }}>
        <FormControlLabel
          id="searchYn"
          name="searchYn"
          label="미사용"
          control={<Checkbox size="small" checked={formik.values.searchYn} onChange={formik.handleChange} />}
        />
      </Box>

      {/* 검색 키워드 */}
      <Box sx={{ gridArea: 'keyword', minWidth: 0 }}>
        <TextField
          {...fieldProps}
          select
          fullWidth
          required
          id="searchKeyword"
          name="searchKeyword"
          label="검색 키워드"
          value={formik.values.searchKeyword}
          onChange={formik.handleChange}
          error={formik.touched.searchKeyword && Boolean(formik.errors.searchKeyword)}
          helperText={formik.touched.searchKeyword && formik.errors.searchKeyword}
        >
          <MenuItem value="usrNm">이름</MenuItem>
          <MenuItem value="usrNo">사번</MenuItem>
          <MenuItem value="dptNm">부서</MenuItem>
          <MenuItem value="gradeNm">직급</MenuItem>
          <MenuItem value="telNo">연락처</MenuItem>
          <MenuItem value="emlAddr">이메일</MenuItem>
        </TextField>
      </Box>

      {/* 검색어 */}
      <Box sx={{ gridArea: 'search', minWidth: 0 }}>
        <TextField
          {...fieldProps}
          fullWidth
          required
          id="searchWords"
          name="searchWords"
          label="검색어"
          value={formik.values.searchWords || ''}
          onChange={formik.handleChange}
          error={formik.touched.searchWords && Boolean(formik.errors.searchWords)}
          helperText={formik.touched.searchWords && formik.errors.searchWords}
        />
      </Box>
    </SearchCard>
  );
};
